<template>
  <v-container v-if="currentIframeTournament" fluid>
  <!-- Vista de tabla general normal -->
   <v-layout row wrap v-if="currentIframeTournament.mode == 'normal'">
       <v-flex xs12 >
           <v-data-table
           :rows-per-page-items="[25,50,100]"
               :headers="headers"
               :items="currentIframeTournament.general_table"
               class="elevation-1"
               light
               hide-actions
               no-results-text=""
               >
               <template slot="items" slot-scope="props">
                   <td class="text-xs-right">{{props.index + 1}}</td>
                   <td class="text-xs-right">{{ props.item.name }}</td>
                   <td class="text-xs-right">{{ props.item.matches_played }}</td>
                   <td class="text-xs-right">{{ props.item.matches_won }}</td>
                   <td class="text-xs-right">{{ props.item.draw_matches }}</td>
                   <td class="text-xs-right">{{ props.item.matches_lost }}</td>
                   <td class="text-xs-right">{{ props.item.goals }}</td>
                   <td class="text-xs-right">{{ props.item.received_goals }}</td>
                   <td class="text-xs-right">{{ props.item.difference_of_goals }}</td>
                   <td class="text-xs-right">{{ props.item.final_points }}</td>
               </template>
           </v-data-table>
       </v-flex>
      </v-layout>


       <!-- Vista de tabla general en grupos -->
       <v-layout row wrap v-if="currentIframeTournament.mode == 'groups'">
         <v-flex xs12 sm12 md12 v-for="(group, i) in currentIframeTournament.general_table_by_groups" :key="i">
           <v-layout row wrap>
             <v-flex xs12 sm12 md12 >
               <h5>{{group.name}}</h5>
             </v-flex>
             <v-flex xs12 >
                 <v-data-table
                 :rows-per-page-items="[25,50,100]"
                     :headers="headers"
                     :items="group.general_table"
                     class="elevation-1"
                     light
                     hide-actions
                     no-results-text=""
                     >
                     <template slot="items" slot-scope="props">
                         <td class="text-xs-right">{{ props.index + 1}}</td>
                         <td class="text-xs-right">{{ props.item.name }}</td>
                         <td class="text-xs-right">{{ props.item.matches_played }}</td>
                         <td class="text-xs-right">{{ props.item.matches_won }}</td>
                         <td class="text-xs-right">{{ props.item.draw_matches }}</td>
                         <td class="text-xs-right">{{ props.item.matches_lost }}</td>
                         <td class="text-xs-right">{{ props.item.goals }}</td>
                         <td class="text-xs-right">{{ props.item.received_goals }}</td>
                         <td class="text-xs-right">{{ props.item.difference_of_goals }}</td>
                         <td class="text-xs-right">{{ props.item.final_points }}

                         </td>
                         <!-- <td class="text-xs-right">{{ props.item.final_points }}</td> -->
                     </template>
                 </v-data-table>
             </v-flex>
           </v-layout>
         </v-flex>

       </v-layout>

   </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Bus from '@/components/bus'


export default {
    name: 'IframeGeneralTable',
    data() {
        return {
          active: 'tab1',
          headers: [
              { text: '#', value: 'position' },
              { text: 'Equipo', value: 'team' },
              { text: 'JJ', value: 'games' },
              { text: 'JG', value: 'wonGames' },
              { text: 'JE', value: 'tiedGames' },
              { text: 'JP', value: 'lostGames' },
              { text: 'GF', value: 'goals' },
              { text: 'GC', value: 'goalsAgainst' },
              { text: 'DIF', value: 'dif' },
              { text: 'PTS', value: 'points' },
          ]
        }

    },
    computed:{
      ...mapGetters([
        "currentIframeTournament"
      ])
    },
    methods: {
      ...mapActions([

      ]),

    },
    mounted() {

    },
    created() {

    }
}

</script>

<style lang="css" scoped>


</style>



// WEBPACK FOOTER //
// src/components/pages/iframe/iframeGeneralTable.vue